
<Modal v-if="showModal" @close="hide()">
  <h6 slot="header" class="modal-title pl-3">
    <span class="subject">{{form ? form.config_json.form_title : ''}}</span>
  </h6>

  <div class="pl-3 pr-3" slot="body">
    <DynamicForm v-if="form" :locale="$locale" :data="form" :textHelpers="textHelpers" @finished="finished"/>

    <div class="text-center" v-else>
        <div class="spinner-border spinner-border-sm" role="status" style="font-size: 12px;">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
  </div>

  <div slot="footer"></div>
</Modal>
